import { type MotionProps, motion } from "framer-motion";
import Link, { type LinkProps } from "next/link";
import type React from "react";
import { linkMotionProperties } from "./animations";

interface MotionLinkProperties extends MotionProps, LinkProps {
  className?: string;
  children: React.ReactNode;
}

function MotionLink({ children, ...properties }: MotionLinkProperties) {
  const MotionComponent = motion.create(Link);

  return (
    <MotionComponent {...linkMotionProperties} {...properties}>
      {children}
    </MotionComponent>
  );
}

export default MotionLink;
